import React from 'react';

import { Accordion, AccordionDetails, styled, Typography, AccordionSummaryProps } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import { FooterLinks } from "../../utils/footerLinks";
import { theme } from "../../utils/theme";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MEFLogo from "../../images/MEF_Logo_PDC_01_small.jpg";

const CustomAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon
        sx={{
          color: "#000",
          padding: "0px !important",
          margin: "0px !important",
        }}
      />
    }
    {...props} // Spread props to pass them down to the MUI AccordionSummary
  />
))(({ theme }) => ({
  margin: 0,
  padding: 0,
  justifyContent: "flex-start !important",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-180deg)",
    margin: 0,
  },
  "& .MuiAccordionSummary-content": {
    margin: 0,
    flexGrow: 0,
    "& .Mui-expanded": {
      flexGrow: 0,
      margin: 0,
    },
  },
}));

const Footer = () => {
  return (
    <Box
      sx={{
        background: theme.palette.primary.light,
        padding: { xs: "15px 20px 10px 20px", md: "8px 0px 10px 0px" },
      }}
    >
      <footer>
        <Grid container spacing={{ xs: 0, md: 2 }} alignItems="center">
          <Grid
            item
            xs={12}
            md={5}
            lg={3}
            textAlign={{ xs: "left", md: "center", display: 'flex', alignItems: 'center' }}
          >
            <img
//              src="/MEF_Logo_PDC_01_130_75.jpg"
          src={MEFLogo}
              alt="logo"
              width={45}
              height={25}
              style={{
                mixBlendMode: "multiply",
                marginRight: '5px'
              }}
            />
            <Typography
              fontWeight={500}
              color="primary"
              variant="body2"
              sx={{
                fontSize: "11px",
              }}
            >
              © 2000-2026 Manchester Economic Forecasting Ltd<br />
              Registered in England & Wales: Number 10461013
            </Typography>
          </Grid>
          {FooterLinks.map((footLinkInfo, index) => (
            <Grid item xs={12} md={2.3} lg={3} key={index}>
              {footLinkInfo?.subLinks?.length > 0 ? (
                <Accordion
                  sx={{
                    background: "transparent",
                    border: "none",
//                    component: "none",
                    boxShadow: "none",
                    padding: "0px !important",
                    margin: "0px !important",
                    "& .MuiAccordionSummary-root.Mui-expanded": {
                      height: "48px",
                      minHeight: "min-content",
                    },
                  }}
                >
                  <CustomAccordionSummary
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography fontWeight={600}>
                      {footLinkInfo?.title}
                    </Typography>
                  </CustomAccordionSummary>
                  {footLinkInfo.subLinks?.length > 0 && (
                    <AccordionDetails
                      sx={{
                        padding: "0px !important",
                        margin: "0px !important",
                      }}
                    >
                      {footLinkInfo.subLinks.map(
                        (subInfo, subIndex) => (
                          <Link to={subInfo?.link} key={subIndex}>
                            <Typography
                              color={theme.palette.primary.main}
                              variant={"body2"}
                              fontWeight={500}
                              sx={{
                                lineHeight: "2em",
                              }}
                            >
                              {subInfo?.name}
                            </Typography>
                          </Link>
                        )
                      )}
                    </AccordionDetails>
                  )}
                </Accordion>
              ) : (
                <Typography fontWeight={500} color="primary" mt={1.5}>
                  {footLinkInfo?.title}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </footer>
    </Box>
  );
};

export default Footer;
